import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../LangContext";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay },
});

export default function Services() {
  const { t } = useLang();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <motion.p {...fade(0)} className="eyebrow text-ink2">
              — {t.services.eyebrow}
            </motion.p>
            <motion.h2
              {...fade(0.05)}
              className="headline mt-6 text-4xl sm:text-5xl lg:text-6xl text-ink"
              data-testid="services-title"
            >
              {t.services.title}
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
            <motion.p
              {...fade(0.1)}
              className="text-lg text-ink2 leading-relaxed"
              data-testid="services-lede"
            >
              {t.services.lede}
            </motion.p>
          </div>
        </div>

        <div className="border-t border-line" data-testid="services-list">
          {t.services.list.map((s, i) => (
            <motion.div
              key={s.k}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.05 }}
              data-testid={`service-row-${s.k}`}
              className="group grid grid-cols-12 gap-4 md:gap-6 border-b border-line py-8 md:py-10 hover:bg-stone50 transition-colors duration-500 px-2 md:px-4"
            >
              <div className="col-span-2 md:col-span-1">
                <span className="text-xs tracking-widest text-ink2">{s.k}</span>
              </div>
              <div className="col-span-10 md:col-span-4">
                <h3 className="font-serif text-2xl md:text-3xl text-ink leading-tight">
                  {s.t}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-6 md:col-start-7">
                <p className="text-base md:text-lg text-ink2 leading-relaxed">{s.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
